function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { HeadingText } from './elements';
export const Subheading = ({
  ...props
}) => /*#__PURE__*/React.createElement(HeadingText, _extends({
  $desktopSize: props.size ?? 4,
  $mobileSize: props.size ?? 3,
  color: "var(--aui-on-surface-soft)"
}, props));